import { useContext } from "react";
import { UNSAFE_LocationContext } from "react-router-dom";
import { useFrameMode } from "./frameMode";
import { useNextFrameMounted } from "./frameMounted";
import { findEntry } from "../routes/switchboard";

/**
 * Whether the person is looking at (or is just about to see) the new frame. Today's app-wide extras (30-day splash, trial box,
 * Get Started card, over-limit banner, "Set your state" bar) ask this to stay out. The frame mounts a moment after the first paint,
 * so the address and the switchboard line count too; otherwise the old pieces flashed over a fresh page (walkthrough decision 5).
 */
export const useNewFrameShown = (): boolean => {
  const mounted = useNextFrameMounted();
  const mode = useFrameMode();
  // Not useLocation(): this also runs in places that may sit outside a Router (the Snackbar in isolated tests).
  const pathname = useContext(UNSAFE_LocationContext)?.location?.pathname ?? window.location.pathname;
  return mounted || mode === "next" || pathname.startsWith("/next/") || findEntry(pathname)?.entry.mode === "next";
};
